import React, { Children, FC } from 'react';
import { Box, BoxProps } from '@mui/material';

export const DashboardHeaderLayout: FC<BoxProps> = ({
  children,
  mb,
  ...props
}) => {
  return (
    <Box
      {...props}
      mt={{
        xs: 5,
        sm: 6,
      }}
      mb={mb ?? { xs: 5, sm: 6 }}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        justifyContent: 'space-between',
        gap: {
          xs: 5,
          sm: 6,
          md: 8,
        },
        overflow: 'visible',
        ...props.sx,
      }}
    >
      {Children.map(children, (child) => (
        <Box sx={{ flex: 1, overflow: 'visible' }}>{child}</Box>
      ))}
    </Box>
  );
};
